import { useBootstrap } from '../context/BootstrapContext'

export function useActivities() {
  const { data, loading } = useBootstrap()
  return { activities: data.activities, loading }
}
